import { useState, useEffect } from 'react';
import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { getFlexSelectCustomStyle } from '../../assets/styles/multiple_select';

export const CreatableFlexSelect = ({
  style,
  controlStyle,
  itemStyle,
  validation,
  value: externalValue = [],
  setValue,
  defaultValue = [],
  placeholder,
  isCommentWithSearch = false
}) => {
  const styleDefault = {
    container: (provided) => ({
      ...provided,
      ...getFlexSelectCustomStyle({ minHeight: '46px' }),
      ...style
    }),
    control: (provided) => ({
      ...provided,
      ...getFlexSelectCustomStyle({ minHeight: '46px' }),
      ...controlStyle
    }),
    placeholder: (provided) => {
      return {
        ...provided,
        fontSize: '14px'
      };
    },
    multiValue: (provided) => ({
      ...provided,
      ...itemStyle
    })
  };
  const createOption = (label) => ({
    label,
    value: label
  });

  const defineDefaultValue = (value) => {
    if (value?.length === 0) return [];
    return value?.map((item) => createOption(item));
  };

  const [inputValue, setInputValue] = useState('');
  const [valueIntern, setValueIntern] = useState(
    defineDefaultValue(defaultValue)
  );

  useEffect(() => {
    if (!isCommentWithSearch) return;
    const formattedValue = defineDefaultValue(externalValue);
    setValueIntern(formattedValue);
  }, [externalValue]);

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    const inputValueWithoutCommas = inputValue.replace(/,/g, '');

    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (validation && validation(inputValueWithoutCommas)) return;
        setValueIntern((prev = []) => [
          ...(prev || []),
          createOption(inputValueWithoutCommas)
        ]);
        setValue((prev = []) => [...(prev || []), inputValueWithoutCommas]);
        setInputValue('');
        event.preventDefault();
    }
  };

  const components = {
    DropdownIndicator: null
  };
  return (
    <CreatableSelect
      styles={styleDefault}
      components={components}
      options={defaultValue?.map((item) => createOption(item))}
      inputValue={inputValue}
      isClearable
      isMulti
      onChange={(newValue) => {
        setValueIntern(newValue);
        setValue(newValue?.map((item) => item.value));
      }}
      onInputChange={(newValue) => setInputValue(newValue)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      value={valueIntern}
    />
  );
};
